var getSortBy = function (columns) {
    var sortedColumn = columns.find(function (_a) {
        var isSortable = _a.isSortable, initialSort = _a.initialSort;
        return isSortable && initialSort;
    });
    if (!sortedColumn)
        return null;
    var getId = function () {
        var id = sortedColumn.id, accessor = sortedColumn.accessor;
        if (typeof id === 'string')
            return id;
        if (typeof accessor === 'string')
            return accessor;
        return null;
    };
    var id = getId();
    if (!id)
        return null;
    return {
        sortBy: [
            {
                id: id,
                desc: sortedColumn.initialSort === 'desc',
            },
        ],
    };
};
export default getSortBy;
//# sourceMappingURL=getSortBy.js.map